import { FC } from "react";
import { IconPropsType } from ".";

export const SendSms: FC<IconPropsType> = (props) => {
  return (
    <svg
      width={props.size ?? 16}
      height={props.size ?? 16}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.70476 10.1282H15.1174H25.9561C26.0479 10.1282 26.1385 10.1336 26.2274 10.1443L18.1902 17.4509C18.0118 17.613 17.7376 17.6065 17.5671 17.436L13.3657 13.2347C12.8366 12.7056 11.9788 12.7056 11.4497 13.2347C10.9206 13.7638 10.9206 14.6216 11.4497 15.1507L15.6511 19.3521C16.8443 20.5453 18.7643 20.591 20.0129 19.4559L28.1856 12.0262C28.2044 12.1434 28.2141 12.2637 28.2141 12.3862V24.1282C28.2141 25.3753 27.2032 26.3862 25.9561 26.3862H9.69802C8.45093 26.3862 7.43996 25.3753 7.43996 24.1282V16.9023C7.43996 16.1541 6.83338 15.5475 6.08512 15.5475C5.33686 15.5475 4.73028 16.1541 4.73028 16.9023V24.1282C4.73028 26.8718 6.95441 29.0959 9.69802 29.0959H25.9561C28.6997 29.0959 30.9238 26.8718 30.9238 24.1282V12.3862C30.9238 9.64261 28.6997 7.41848 25.9561 7.41848H15.1174L7.70476 7.41848L10.0225 5.24559C10.5684 4.73383 10.596 3.87644 10.0843 3.33056C9.57251 2.78468 8.71512 2.75702 8.16924 3.26878L3.35204 7.78491C3.07883 8.04104 2.92383 8.39883 2.92383 8.77332C2.92383 9.1478 3.07883 9.50559 3.35204 9.76172L8.16924 14.2779C8.71512 14.7896 9.57251 14.762 10.0843 14.2161C10.596 13.6702 10.5684 12.8128 10.0225 12.301L7.70476 10.1282Z"
        fill={props.color ?? "#FF6262"}
      />
    </svg>
  );
};
